module.exports = __webpack_public_path__ + "img/music.8f6952d4.png";